import * as CONSTANTS from 'common/constants/analyst-dashboards';

export const columns = [
  {
    id: CONSTANTS.COMPANY_NAME_KEY,
    label: CONSTANTS.COMPANY_NAME,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.STATUS_KEY,
    label: CONSTANTS.STATUS,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.NOTES_KEY,
    label: CONSTANTS.NOTES,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.OTHER_CONSULTANT_KEY,
    label: CONSTANTS.OTHER_CONSULTANT,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.ENGAGEMENT_MANAGER_KEY,
    label: CONSTANTS.ENGAGEMENT_MANAGER,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.VALUATION_DATE_KEY,
    label: CONSTANTS.VALUATION_DATE,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.CREATED_AT_KEY,
    label: CONSTANTS.CREATED_AT,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.VALUATION_FEE_KEY,
    label: CONSTANTS.VALUATION_FEE,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.SUPPORTING_DUE_DATE_KEY,
    label: CONSTANTS.SUPPORTING_DUE_DATE,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.DEAL_KEY,
    label: CONSTANTS.DEAL,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.DEAL_DUE_KEY,
    label: CONSTANTS.DEAL_DUE,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.DEAL_STAGE_KEY,
    label: CONSTANTS.DEAL_STAGE,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.NET_VALUE_KEY,
    label: CONSTANTS.NET_VALUE,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.SPLIT_KEY,
    label: CONSTANTS.SPLIT,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.PAYMENT_1_KEY,
    label: CONSTANTS.PAYMENT_1,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.PAY_1_DATE_KEY,
    label: CONSTANTS.PAY_1_DATE,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.PAYMENT_2_KEY,
    label: CONSTANTS.PAYMENT_2,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.PAY_2_DATE_KEY,
    label: CONSTANTS.PAY_2_DATE,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.PAYMENT_3_KEY,
    label: CONSTANTS.PAYMENT_3,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.PAY_3_DATE_KEY,
    label: CONSTANTS.PAY_3_DATE,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.REFUND_KEY,
    label: CONSTANTS.REFUND,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.REFUND_DATE_KEY,
    label: CONSTANTS.REFUND_DATE,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.ADJUSTMENT_KEY,
    label: CONSTANTS.ADJUSTMENT,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.ADJUSTMENT_DATE_KEY,
    label: CONSTANTS.ADJUSTMENT_DATE,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.BAD_DEBT_KEY,
    label: CONSTANTS.BAD_DEBT,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.BAD_DEBT_DATE_KEY,
    label: CONSTANTS.BAD_DEBT_DATE,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
  {
    id: CONSTANTS.RENEWAL_RATE_KEY,
    label: CONSTANTS.RENEWAL_RATE,
    isSortable: true,
    align: 'left',
    disablePadding: false,
  },
];
